// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Login from './pages/Login';
// import Guest from './pages/Guest';
// import SignupPage from './pages/SignupPage';
// import Home from './pages/Home';
// import Profile from './pages/Profile';
// import Help from './pages/Help';
// import PrivateRoute from './pages/PrivateRoute';
// import ErrorPage from './pages/ErrorPage';
// import MyFamilyTree from './pages/MyFamilyTree';
// import MyFamily from './pages/MyFamily';
// import FindRelation from './pages/FindRelation';
// import Gallery from './pages/Gallery';
// import Setting from './pages/Setting';
// import Partner from './pages/Partner';
// import UpgradePage from './pages/UpgradePage';
// import AdminPage from './pages/AdminPage';
// import AdminInvoices from './pages/AdminInvoices';
// import AdminRoute from './components/AdminRoute';
// import { ThemeProvider } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import theme from './theme';
// import Welcome from './pages/Welcome';
// import Footer from './components/Footer';
// import { Box } from '@mui/material';
// import PrivacyPolicy from './pages/PrivacyPolicy';
// import TermsOfService from './pages/TermsOfService';
// import ContactUs from './pages/ContactUs';
// import { ErrorProvider } from './ErrorContext';
// import Logout from './pages/Logout';
// import GlobalErrorHandler from './GlobalErrorHandler';
// import UpgradeModal from './components/UpgradeModal';
// import useAccess from './hooks/useAccess';

// // Public routes where modal must NEVER trigger
// const PUBLIC_ROUTES = ['/', '/login', '/signup', '/guest', '/contact-us', '/privacy-policy', '/terms-of-service', '/logout', '/upgrade'];

// const isPublicRoute = () => {
//   const path = window.location.pathname.replace('/goldpetals', '') || '/';
//   return PUBLIC_ROUTES.some(route => path === route || path.startsWith(route + '/') || path.startsWith(route + '?'));
// };

// const isUserLoggedIn = () => {
//   const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
//   const userId = localStorage.getItem('uid') || localStorage.getItem('userId');
//   return isLoggedIn && !!userId;
// };

//  const [role, setRole] = useState(localStorage.getItem('role'));

// useEffect(() => {
//   const syncRole = () => {
//     setRole(localStorage.getItem('role'));
//   };

//   window.addEventListener('storage', syncRole);

//   return () => window.removeEventListener('storage', syncRole);
// }, []);


// const isAdminUser = () => role === '1';


// function App() {
//   const { isFree, loading } = useAccess();
//   const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  
//   const [openUpgrade, setOpenUpgrade] = useState(false);
//   const [featureLabel, setFeatureLabel] = useState('');


// };

// const handleClose = () => {
//   setOpenUpgrade(false);
// };

// useEffect(() => {
//   const handleGlobalClick = (e) => {
//     if (loading) return;

//     const admin = isAdminUser();
//     const loggedIn = isUserLoggedIn();

//     // ✅ ADMIN BYPASS (MAIN FIX)
//     if (admin) return;

//     // ✅ PREMIUM BYPASS
//     if (!isFree) return;

//     // ❌ Not logged in → allow
//     if (!loggedIn) return;

//     // ❌ Public routes → allow
//     if (isPublicRoute()) return;

//     // ❌ Allow modal + system links
//     if (
//       e.target.closest('.MuiDialog-root') || 
//       e.target.closest('[href*="logout"]') || 
//       e.target.closest('[data-logout]') || 
//       e.target.closest('[href*="upgrade"]') || 
//       e.target.closest('[data-upgrade]')
//     ) return;

//     // 🚫 BLOCK ONLY FREE USERS
//     e.preventDefault();
//     e.stopPropagation();

//     setOpenUpgrade(false);

//     setTimeout(() => {
//       setFeatureLabel('Full Access Required');
//       setOpenUpgrade(true);
//     }, 0);
//   };

//   document.addEventListener('click', handleGlobalClick, true);

//   const handleExplicitUpgrade = (e) => {
//     if (loading) return;

//     const admin = isAdminUser();

//     // ✅ ADMIN BYPASS
//     if (admin) return;

//     // ✅ PREMIUM BYPASS
//     if (!isFree) return;

//     if (isPublicRoute()) return;

//     setFeatureLabel(e.detail?.feature || 'Upgrade Required');
//     setOpenUpgrade(true);
//   };

//   window.addEventListener('goldpetals:open-upgrade', handleExplicitUpgrade);

//   return () => {
//     document.removeEventListener('click', handleGlobalClick, true);

//     // ✅ FIX (important)
//     window.removeEventListener('goldpetals:open-upgrade', handleExplicitUpgrade);
//   };
// }, [isFree, loading]);
//   return (
//     <GlobalErrorHandler>
//       <ErrorProvider>
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           minHeight: '100vh',
//         }}
//       >
//         <Router basename="/goldpetals">
//           <Box sx={{ flex: 1 }}>
//             <Routes>
//               <Route path="/" element={<Welcome />} />
//               <Route path="/login" element={<Login />} />
//               <Route path="/guest" element={<Guest />} />
//               <Route path="/signup" element={<SignupPage />} />
//               <Route path="/contact-us" element={<ContactUs />} />

//               {/* Admin routes */}
//               <Route element={<AdminRoute />}>
//                 <Route path="/dashboard" element={<AdminPage />} />
//                 <Route path="/admin/dashboard" element={<AdminPage />} />
//                 <Route path="/admin/invoices" element={<AdminInvoices />} />
//               </Route>

//               {/* Private routes */}
//               <Route element={<PrivateRoute isLoggedIn={isLoggedIn} />}>
//                 <Route path="/find-partner" element={<Partner />} />
//                 <Route path="/upgrade" element={<UpgradePage />} />
//                 <Route path="/find-relation" element={<FindRelation />} />
//                 <Route path="/my-family-tree" element={<MyFamily />} />
//                 <Route path="/find-people" element={<Home />} />
//                 <Route path="/settings" element={<Setting />} />
//                 <Route path="/home" element={<MyFamilyTree />} />
//                 <Route path="/profile" element={<Profile />} />
//                 <Route path="/help" element={<Help />} />
//                 <Route path="/picture-gallery" element={<Gallery />} />
//               </Route>

//               <Route path="/logout" element={<Logout />} />
//               <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//               <Route path="/terms-of-service" element={<TermsOfService />} />
//               <Route path="*" element={<ErrorPage />} />
//             </Routes>
//           </Box>

//           {/* Optional Footer */}
//           <Footer />
//         </Router>

//         <UpgradeModal
//           open={openUpgrade}
//           onClose={handleClose}
//           featureLabel={featureLabel}
//         />
//       </Box>
//     </ThemeProvider>
//       </ErrorProvider>
//     </GlobalErrorHandler>
//   );
// }

// export default App;




// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// import Login from './pages/Login';
// import Guest from './pages/Guest';
// import SignupPage from './pages/SignupPage';
// import Home from './pages/Home';
// import Profile from './pages/Profile';
// import Help from './pages/Help';
// import PrivateRoute from './pages/PrivateRoute';
// import ErrorPage from './pages/ErrorPage';
// import MyFamilyTree from './pages/MyFamilyTree';
// import MyFamily from './pages/MyFamily';
// import FindRelation from './pages/FindRelation';
// import Gallery from './pages/Gallery';
// import Setting from './pages/Setting';
// import Partner from './pages/Partner';
// import UpgradePage from './pages/UpgradePage';
// import AdminPage from './pages/AdminPage';
// import AdminInvoices from './pages/AdminInvoices';
// import AdminRoute from './components/AdminRoute';

// import { ThemeProvider } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import theme from './theme';

// import Welcome from './pages/Welcome';
// import Footer from './components/Footer';
// import { Box } from '@mui/material';

// import PrivacyPolicy from './pages/PrivacyPolicy';
// import TermsOfService from './pages/TermsOfService';
// import ContactUs from './pages/ContactUs';

// import { ErrorProvider } from './ErrorContext';
// import Logout from './pages/Logout';
// import GlobalErrorHandler from './GlobalErrorHandler';
// import UpgradeModal from './components/UpgradeModal';
// import useAccess from './hooks/useAccess';

// const PUBLIC_ROUTES = [
//   '/',
//   '/login',
//   '/signup',
//   '/guest',
//   '/contact-us',
//   '/privacy-policy',
//   '/terms-of-service',
//   '/logout',
//   '/upgrade'
// ];

// function App() {
//   const { isFree, isAdmin, loading } = useAccess();

//   const isLoggedIn =
//     localStorage.getItem('isLoggedIn') === 'true';

//   const [openUpgrade, setOpenUpgrade] = useState(false);
//   const [featureLabel, setFeatureLabel] = useState('');

//   const isPublicRoute = () => {
//     const path =
//       window.location.pathname.replace('/goldpetals', '') || '/';

//     return PUBLIC_ROUTES.some(
//       (route) =>
//         path === route ||
//         path.startsWith(route + '/') ||
//         path.startsWith(route + '?')
//     );
//   };

//   const isUserLoggedIn = () => {
//     const logged =
//       localStorage.getItem('isLoggedIn') === 'true';
//     const userId =
//       localStorage.getItem('uid') ||
//       localStorage.getItem('userId');

//     return logged && !!userId;
//   };

//   const handleClose = () => {
//     setOpenUpgrade(false);
//   };

//   useEffect(() => {
//     const handleGlobalClick = (e) => {
//       if (loading) return;

//       const loggedIn = isUserLoggedIn();

//       // ✅ 1. ADMIN → NEVER SHOW MODAL
//       if (isAdmin) return;

//       // ✅ 2. PREMIUM → NEVER SHOW MODAL
//       if (!isFree) return;

//       // ❌ not logged in
//       if (!loggedIn) return;

//       // ❌ public route
//       if (isPublicRoute()) return;

//       // ❌ allow safe UI areas
//       if (
//         e.target.closest('.MuiDialog-root') ||
//         e.target.closest('[href*="logout"]') ||
//         e.target.closest('[href*="upgrade"]')
//       )
//         return;

//       // 🚫 BLOCK FREE USER ACTIONS
//       e.preventDefault();
//       e.stopPropagation();

//       setOpenUpgrade(false);

//       setTimeout(() => {
//         setFeatureLabel('Full Access Required');
//         setOpenUpgrade(true);
//       }, 0);
//     };

//     document.addEventListener('click', handleGlobalClick, true);

//     const handleExplicitUpgrade = (e) => {
//       if (loading) return;

//       // ✅ ADMIN SKIP
//       if (isAdmin) return;

//       // ✅ PREMIUM SKIP
//       if (!isFree) return;

//       if (isPublicRoute()) return;

//       setFeatureLabel(e.detail?.feature || 'Upgrade Required');
//       setOpenUpgrade(true);
//     };

//     window.addEventListener(
//       'goldpetals:open-upgrade',
//       handleExplicitUpgrade
//     );

//     return () => {
//       document.removeEventListener(
//         'click',
//         handleGlobalClick,
//         true
//       );

//       window.removeEventListener(
//         'goldpetals:open-upgrade',
//         handleExplicitUpgrade
//       );
//     };
//   }, [isFree, isAdmin, loading]);

//   return (
//     <GlobalErrorHandler>
//       <ErrorProvider>
//         <ThemeProvider theme={theme}>
//           <CssBaseline />

//           <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
//             <Router basename="/goldpetals">
//               <Box sx={{ flex: 1 }}>
//                 <Routes>
//                   <Route path="/" element={<Welcome />} />
//                   <Route path="/login" element={<Login />} />
//                   <Route path="/guest" element={<Guest />} />
//                   <Route path="/signup" element={<SignupPage />} />
//                   <Route path="/contact-us" element={<ContactUs />} />

//                   <Route element={<AdminRoute />}>
//                     <Route path="/dashboard" element={<AdminPage />} />
//                     <Route path="/admin/dashboard" element={<AdminPage />} />
//                     <Route path="/admin/invoices" element={<AdminInvoices />} />
//                   </Route>

//                   <Route element={<PrivateRoute isLoggedIn={isLoggedIn} />}>
//                     <Route path="/find-partner" element={<Partner />} />
//                     <Route path="/upgrade" element={<UpgradePage />} />
//                     <Route path="/find-relation" element={<FindRelation />} />
//                     <Route path="/my-family-tree" element={<MyFamily />} />
//                     <Route path="/find-people" element={<Home />} />
//                     <Route path="/settings" element={<Setting />} />
//                     <Route path="/home" element={<MyFamilyTree />} />
//                     <Route path="/profile" element={<Profile />} />
//                     <Route path="/help" element={<Help />} />
//                     <Route path="/picture-gallery" element={<Gallery />} />
//                   </Route>

//                   <Route path="/logout" element={<Logout />} />
//                   <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//                   <Route path="/terms-of-service" element={<TermsOfService />} />
//                   <Route path="*" element={<ErrorPage />} />
//                 </Routes>
//               </Box>

//               <Footer />
//             </Router>

//             <UpgradeModal
//               open={openUpgrade}
//               onClose={handleClose}
//               featureLabel={featureLabel}
//             />
//           </Box>
//         </ThemeProvider>
//       </ErrorProvider>
//     </GlobalErrorHandler>
//   );
// }

// export default App;



import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Login from './pages/Login';
import Guest from './pages/Guest';
import SignupPage from './pages/SignupPage';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Help from './pages/Help';
import PrivateRoute from './pages/PrivateRoute';
import ErrorPage from './pages/ErrorPage';
import MyFamilyTree from './pages/MyFamilyTree';
import MyFamily from './pages/MyFamily';
import FindRelation from './pages/FindRelation';
import Gallery from './pages/Gallery';
import Setting from './pages/Setting';
import Partner from './pages/Partner';
import UpgradePage from './pages/UpgradePage';
import AdminPage from './pages/AdminPage';
import AdminAddressPage from './pages/AdminAddressPage';
import AdminInvoices from './pages/AdminInvoices';
import AdminRoute from './components/AdminRoute';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

import Welcome from './pages/Welcome';
import Footer from './components/Footer';
import { Box } from '@mui/material';

import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ContactUs from './pages/ContactUs';

import { ErrorProvider } from './ErrorContext';
import Logout from './pages/Logout';
import GlobalErrorHandler from './GlobalErrorHandler';
import UpgradeModal from './components/UpgradeModal';
import useAccess from './hooks/useAccess';

const PUBLIC_ROUTES = [
  '/',
  '/login',
  '/signup',
  '/guest',
  '/contact-us',
  '/privacy-policy',
  '/terms-of-service',
  '/logout',
  '/upgrade'
];

function App() {
  const { isFree, isAdmin, loading } = useAccess();

  const [openUpgrade, setOpenUpgrade] = useState(false);
  const [featureLabel, setFeatureLabel] = useState('');

  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  // ✅ FIX 1: Always read fresh role (no stale closure issue)
  const getIsAdmin = useCallback(() => {
    return localStorage.getItem('role') === '1';
  }, []);

  const isPublicRoute = useCallback(() => {
    const path = window.location.pathname.replace('/goldpetals', '') || '/';
    return PUBLIC_ROUTES.some(
      route =>
        path === route ||
        path.startsWith(route + '/') ||
        path.startsWith(route + '?')
    );
  }, []);

  const isUserLoggedIn = useCallback(() => {
    return (
      localStorage.getItem('isLoggedIn') === 'true' &&
      !!(localStorage.getItem('uid') || localStorage.getItem('userId'))
    );
  }, []);

  const handleClose = () => setOpenUpgrade(false);

  useEffect(() => {
    // const handleGlobalClick = (e) => {
    //   if (loading) return;

    //   const isAdminUser = getIsAdmin(); // 🔥 ALWAYS FRESH VALUE

    //   const loggedIn = isUserLoggedIn();

    //   // ✅ ADMIN → HARD BYPASS
    //   if (isAdminUser) return;

    //   // ✅ PREMIUM → BYPASS
    //   if (!isFree) return;

    //   // ❌ not logged in
    //   if (!loggedIn) return;

    //   // ❌ public route
    //   if (isPublicRoute()) return;

    //   // ❌ allow UI safe zones
    //   if (
    //     e.target.closest('.MuiDialog-root') ||
    //     e.target.closest('[href*="logout"]') ||
    //     e.target.closest('[href*="upgrade"]')
    //   ) return;

    //   // 🚫 BLOCK FREE USER
    //   e.preventDefault();
    //   e.stopPropagation();

    //   setOpenUpgrade(false);

    //   setTimeout(() => {
    //     setFeatureLabel('Full Access Required');
    //     setOpenUpgrade(true);
    //   }, 0);
    // };

    const handleGlobalClick = (e) => {
  if (loading) return;

  const isAdminUser = getIsAdmin();
  const loggedIn = isUserLoggedIn();

  // ✅ ADMIN → NO MODAL
  if (isAdminUser) return;

  // ✅ PREMIUM → NO MODAL
  //if (!isFree) return;
  const subscription = localStorage.getItem('subscription');

const isPremiumUser =
  subscription === '1' ||
  subscription === '2' ||
  subscription === '3';

// ✅ PREMIUM → HARD BYPASS (NO MODAL EVER)
if (isPremiumUser || !isFree) return;

  // ❌ not logged in
  if (!loggedIn) return;

  // ❌ public route
  if (isPublicRoute()) return;

  const target = e.target;

  // ✅ SAFE AREA 1: ANY RIGHT CLICK MENU ACTION / CONTEXT MENU
  if (e.type === 'contextmenu') return;

  // ✅ SAFE AREA 2: LOGOUT (ANY ELEMENT, NOT ONLY href)
  if (
    target.closest('[data-action="logout"]') ||
    target.closest('[href*="logout"]') ||
    target.innerText?.toLowerCase?.().includes('logout')
  ) {
    return;
  }

  // ✅ SAFE AREA 3: UPGRADE BUTTON (SIDEBAR OR ANYWHERE)
  if (
    target.closest('[data-action="upgrade"]') ||
    target.closest('[href*="upgrade"]') ||
    target.closest('[data-upgrade="true"]')
  ) {
    return;
  }

  // ❌ allow modal UI interaction
  if (
    target.closest('.MuiDialog-root')
  ) return;

  // 🚫 BLOCK FREE USERS ONLY
  e.preventDefault();
  e.stopPropagation();

  setOpenUpgrade(false);

  setTimeout(() => {
    setFeatureLabel('Full Access Required');
    setOpenUpgrade(true);
  }, 0);
};

   // document.addEventListener('click', handleGlobalClick, true);
   document.addEventListener('click', handleGlobalClick, true);
document.addEventListener('contextmenu', handleGlobalClick, true);

    const handleExplicitUpgrade = (e) => {
      if (loading) return;

      const isAdminUser = getIsAdmin();

      if (isAdminUser) return;
      if (!isFree) return;
      if (isPublicRoute()) return;

      setFeatureLabel(e.detail?.feature || 'Upgrade Required');
      setOpenUpgrade(true);
    };

    window.addEventListener('goldpetals:open-upgrade', handleExplicitUpgrade);

    return () => {
      document.removeEventListener('click', handleGlobalClick, true);
      window.removeEventListener('goldpetals:open-upgrade', handleExplicitUpgrade);
    };
  }, [isFree, loading, getIsAdmin, isUserLoggedIn, isPublicRoute]);

  return (
    <GlobalErrorHandler>
      <ErrorProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Router basename="/goldpetals">
              <Box sx={{ flex: 1 }}>
                <Routes>
                  <Route path="/" element={<Welcome />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/guest" element={<Guest />} />
                  <Route path="/signup" element={<SignupPage />} />
                  <Route path="/contact-us" element={<ContactUs />} />

                  <Route element={<AdminRoute />}>
                    <Route path="/dashboard" element={<AdminPage />} />
                    <Route path="/admin/dashboard" element={<AdminPage />} />
                    <Route path="/admin/addresses" element={<AdminAddressPage />} />
                    <Route path="/admin/invoices" element={<AdminInvoices />} />
                  </Route>

                  <Route element={<PrivateRoute isLoggedIn={isLoggedIn} />}>
                    <Route path="/find-partner" element={<Partner />} />
                    <Route path="/upgrade" element={<UpgradePage />} />
                    <Route path="/find-relation" element={<FindRelation />} />
                    <Route path="/my-family-tree" element={<MyFamily />} />
                    <Route path="/find-people" element={<Home />} />
                    <Route path="/settings" element={<Setting />} />
                    <Route path="/home" element={<MyFamilyTree />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/help" element={<Help />} />
                    <Route path="/picture-gallery" element={<Gallery />} />
                  </Route>

                  <Route path="/logout" element={<Logout />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="*" element={<ErrorPage />} />
                </Routes>
              </Box>

              <Footer />
            </Router>

            <UpgradeModal
              open={openUpgrade}
              onClose={handleClose}
              featureLabel={featureLabel}
            />
          </Box>
        </ThemeProvider>
      </ErrorProvider>
    </GlobalErrorHandler>
  );
}

export default App;